<!-- 学校-课程开班统计 -->
<template>
  <div class="container">
    <div class="index" v-show="!detail.show">
      <div class="title">
        <span>{{$route.name}}</span>
      </div>

      <header>
        <div class="header-item" style="width:35%">
          <div class="header-item-title">
            <span class="circle"></span>
            <span>课程开班统计</span>
          </div>
          <div id="echarts-box1"></div>
        </div>

        <div class="header-item" style="width:20%">
          <div class="header-item-title" style="height:24px">
          </div>
          <div id="echarts-box2"></div>
        </div>

        <div class="header-item" style="width:45%">
          <div class="header-item-title">
            <span class="circle"></span>
            <span>课程报名率TOP5</span>
          </div>
          <div id="echarts-box3"></div>
        </div>
      </header>

      <div class="query">
        <el-form ref="form" :inline="true" :model="form" label-width="90px">
          <el-form-item label="">
            <el-select
              v-model="form.schoolYearSemester"
              placeholder="选择学年学期"
              clearable
              @clear="searchFun()"
            >
              <el-option
                v-for="item in semesterList"
                :key="item.id"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select
              v-model="form.courseType"
              clearable
              @clear="searchFun()"
              placeholder="课程分类"
            >
              <el-option
                v-for="item in courseTypeList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="">
            <el-select
              v-model="queryParams.campus"
              clearable
              @clear="searchFun()"
              placeholder="选择校区"
              class="label"
            >
              <el-option
                v-for="item in campusList"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select
              v-model="queryParams.gradeId"
              clearable
              @clear="searchFun()"
              placeholder="选择年级"
              class="label"
            >
              <el-option
                v-for="item in gradeList"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="">
            <el-input
              v-model="form.courseName"
              clearable
              placeholder="请输入课程名称"
            />
          </el-form-item>
          <el-form-item label="">
            <el-button type="primary" size="small" @click="searchFun"
              >搜索</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <div class="table">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
        >
          <el-table-column
            align="center"
            prop="courseName"
            label="课程名称"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column align="center" prop="ly" label="课程来源">
          </el-table-column>
          <el-table-column align="center" prop="teacherName" label="任课教师">
          </el-table-column>
          <!-- <el-table-column align="center" prop="end_time" label="所属单位">
          </el-table-column> -->
          <el-table-column
            align="center"
            prop="typeName"
            label="课程分类"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column align="center" prop="fl" label="开班类型">
          </el-table-column>
          <el-table-column
            align="center"
            prop="classNum"
            label="课时总数"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="gradeName"
            label="招生年级"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column align="center" prop="locationName" label="上课地点">
          </el-table-column>
          <el-table-column align="center" prop="selectedCount" label="招生数">
          </el-table-column>
          <el-table-column align="center" prop="totalLimit" label="报名数">
          </el-table-column>
          <el-table-column align="center" prop="signRate" label="报名率">
          </el-table-column>
          <el-table-column align="center" label="操作" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" @click="toDetail(scope)"
                >查看详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--分页组件-->
      <el-pagination
        background
        :current-page="page.pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="page.pageSize"
        :total="page.totalPage"
        layout="total,prev, pager, next,jumper,sizes"
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
      ></el-pagination>
    </div>
    <Detail :info="detail.info" v-if="detail.show" @to-index="toIndex"></Detail>
  </div>
</template>

<script>
import api from "@/api/wisdomSchool/index";
import * as echarts from "echarts";
export default {
  components: {
    Detail: () => import("./details.vue"),
  },
  data() {
    return {
      form: {
        schoolYearSemester: "",
        courseType: "",
        gradeId: "",
        courseName: "",
      },
      page: {
        pageNum: 1,
        pageSize: 10,
        totalPage: 0,
      },
      tableData: [
        {courseName:'科技编程',ly:'本校',teacherName:'谢文华',typeName:'社团活动',fl:'社团班',classNum:'30',gradeName:'一年级二年级三年级',locationName:'微机教室',totalLimit:'50',selectedCount:'42',signRate:'84.00%'},
        {courseName:'科技编程',ly:'本校',teacherName:'单楚苏',typeName:'劳动',fl:'社团班',classNum:'30',gradeName:'一年级二年级三年级',locationName:'二年级3班',totalLimit:'50',selectedCount:'42',signRate:'84.00%'},
        {courseName:'科技编程',ly:'本校',teacherName:'陈正清',typeName:'艺术',fl:'社团班',classNum:'30',gradeName:'一年级二年级三年级',locationName:'微机教室',totalLimit:'50',selectedCount:'42',signRate:'84.00%'},
        {courseName:'科技编程',ly:'本校',teacherName:'朱政廷',typeName:'作业辅导',fl:'托管班',classNum:'50',gradeName:'一年级二年级三年级',locationName:'二年级3班',totalLimit:'50',selectedCount:'42',signRate:'84.00%'},
        {courseName:'科技编程',ly:'本校',teacherName:'邓诗涵',typeName:'科普',fl:'托管班',classNum:'30',gradeName:'一年级二年级三年级',locationName:'二年级3班',totalLimit:'50',selectedCount:'42',signRate:'84.00%'},
        {courseName:'科技编程',ly:'本校',teacherName:'陈正清',typeName:'兴趣小组',fl:'社团班',classNum:'50',gradeName:'一年级二年级三年级',locationName:'二年级3班',totalLimit:'50',selectedCount:'42',signRate:'84.00%'},
        {courseName:'科技编程',ly:'本校',teacherName:'赵鹏',typeName:'作业辅导',fl:'托管班',classNum:'50',gradeName:'一年级二年级三年级',locationName:'美术教室',totalLimit:'50',selectedCount:'42',signRate:'84.00%'},
        {courseName:'科技编程',ly:'本校',teacherName:'邓诗涵',typeName:'劳动',fl:'社团班',classNum:'50',gradeName:'一年级二年级三年级',locationName:'阶梯教室',totalLimit:'50',selectedCount:'42',signRate:'84.00%'},
        {courseName:'科技编程',ly:'本校',teacherName:'邓诗涵',typeName:'问题',fl:'社团班',classNum:'50',gradeName:'一年级二年级三年级',locationName:'校体育馆',totalLimit:'50',selectedCount:'42',signRate:'84.00%'},
        {courseName:'科技编程',ly:'本校',teacherName:'吴博俊',typeName:'艺术',fl:'社团班',classNum:'50',gradeName:'一年级二年级三年级',locationName:'音乐教室',totalLimit:'50',selectedCount:'42',signRate:'84.00%'},
      ],
      semesterList: [
        {id:'xq1',label:'2021~2022年度下学期'},
				{id:'xq2',label:'2021~2022年度上学期'},
				{id:'xq3',label:'2020~2021年度下学期'},
				{id:'xq4',label:'2020~2021年度上学期'},
				{id:'xq5',label:'2019~2020年度下学期'},
				{id:'xq6',label:'2019~2020年度上学期'},
      ],
      courseTypeList: JSON.parse(sessionStorage.getItem("courseTypeList"))||[
        {id:'type1',name:'作业辅导'},
        {id:'type2',name:'科普'},
        {id:'type3',name:'文体'},
        {id:'type4',name:'艺术'},
        {id:'type5',name:'劳动'},
        {id:'type6',name:'阅读'},
        {id:'type7',name:'兴趣小组'},
        {id:'type8',name:'社团活动'},
        {id:'type9',name:'其他'},
      ],
      semesterArr: JSON.parse(sessionStorage.getItem("semesterList"))||[],
      detail: {
        info: {},
        show: false,
      },
    };
  },
  mounted() {
    this.getDataList();
    if(this.semesterArr && this.semesterArr.length>0){
      this.semesterList = this.semesterArr.map((v) => ({
        label: v.schoolYear + "年度" + (v.semester === 1 ? "上学期" : "下学期"),
        value: v.schoolYear + "_" + v.semester,
        id: v.id,
      }));
    }
    this.init();
  },
  created() {

  },
  methods: {
    async getDataList() {
      let params = {
        schoolYearSemester: this.form.schoolYearSemester,
        gradeId: this.form.gradeId,
        courseName: this.form.courseName,
        extOrgName: "",
        typeId: this.form.courseType,
        teacherId: "",
        orgId:sessionStorage.getItem('orgId'),
        platformCode:sessionStorage.getItem('platformCode'),
        page: this.page.pageNum,
        limit: this.page.pageSize,
      };
      // var { data, code } = await api.handleCourseList(params);
      // console.log("获取开班列表数据---", this.form.schoolYearSemester);
      // if (code == "0") {
      //   this.tableData = data.list;
      //   this.page.totalPage = data.total;
      //   // this.page.pageNum = data.pageNum;
      // }
    },
    searchFun() {
      //       for( var key in obj1 ){
      //     obj2[key]=obj[key]
      // }
      // var params = Object.assign({}, obj);
      this.page.pageNum = 1;
      this.getDataList();
    },
    sizeChangeHandle(val) {
      this.tableData = [];
      this.page.pageSize = val;
      this.getDataList();
    },
    currentChangeHandle(val) {
      this.tableData = [];
      this.page.pageNum = val;
      this.getDataList();
    },
    toDetail(scope) {
      console.log(scope);
      this.detail.info = scope.row;
      this.detail.show = true;
    },
    toIndex() {
      this.detail.show = false;
    },
    init(){
      	let vm = this;
      	this.$nextTick(() => {
        	// 圆环图
        	let chartDom1 = document.getElementById('echarts-box1');
        	let myChart1 = echarts.init(chartDom1);
        	let option1 = {
            legend: {
              // data: [],
              // orient: 'vertical',
              left: 'center',
              top: 'bottom',
              icon : 'circle',
            },
            series: [
              {
              name: '',
              type: 'pie',
              radius: ['38%', '50%'], // 这个属性修改环形宽度
              avoidLabelOverlap: false,
              itemStyle: {
                borderRadius: 0,
                borderColor: '#fff',
                borderWidth: 0,
              },
              label: {
                show: false,
                position: 'center',
              },
              emphasis: {
                label: {
                show: false,
                fontSize: '16',
                fontWeight: 'bold',
                },
              },
              labelLine: {
                show: false,
              },
              data: [
                { value: 60, name: '作业辅导' },
                { value: 158, name: '科普' },
                { value: 60, name: '文体' },
                { value: 158, name: '艺术' },
                { value: 60, name: '劳动' },
                { value: 158, name: '阅读' },
                { value: 158, name: '其他' },
              ],
              },
            ],
            // 圆环颜色
            color: ['#51D6A6', '#5BB0FF', '#757FFD', '#D375FD', '#F27676', '#F49562', '#EFD051'],
          };
          myChart1.setOption(option1);

          // 圆环图
        	let chartDom2 = document.getElementById('echarts-box2');
        	let myChart2 = echarts.init(chartDom2);
        	let option2 = {
            legend: {
              // data: [],
              // orient: 'vertical',
              left: 'center',
              top: 'bottom',
              icon : 'circle',
            },
            series: [
              {
              name: '',
              type: 'pie',
              radius: ['61%', '78%'], // 这个属性修改环形宽度
              avoidLabelOverlap: false,
              itemStyle: {
                borderRadius: 0,
                borderColor: '#fff',
                borderWidth: 0,
              },
              label: {
                show: false,
                position: 'center',
              },
              emphasis: {
                label: {
                show: false,
                fontSize: '16',
                fontWeight: 'bold',
                },
              },
              labelLine: {
                show: false,
              },
              data: [
                { value: 60, name: '社团班数量' },
                { value: 158, name: '托管班数量' },
              ],
              },
            ],
            // 圆环颜色
            color: ['#5BB0FF', '#51D6A6', ],
          };
          myChart2.setOption(option2);

        // 柱状图
        let chartDom3 = document.getElementById('echarts-box3');
        let myChart3 = echarts.init(chartDom3);
        let option3 = {
          grid: {
            height: 200,
            top: 36,
            left: 42,
          },
          xAxis: {
            type: 'category',
            data: ['自主\n作业', '社团课', '经典\n诵读', '科普\n天地', '文化\n传播'],
            axisLine: {
              //坐标线
              lineStyle: {
                type: 'solid',
                color: '#DDDDDD', //轴线的颜色
                width: '1', //坐标线的宽度
              },
            },
            axisLabel: {
              textStyle: {
                color: '#999999', //坐标值的具体的颜色
              },
            },
          },
          yAxis: {
            type: 'value',
          },
          series: [
            {
              data: [64, 63, 60, 59, 42],
              type: 'bar',
              showBackground: true,
              backgroundStyle: {
                // 背景颜色
                color: 'none', //'#E8F6FF'
              },
              itemStyle: {
                // 柱子颜色
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 1, color: '#5BB0FF' },
                  ]),
                  label: {
                    formatter: "{c}%",
                    show: true,
                    position: "top",
                    textStyle: {
                      fontSize: "12",
                      color: "#999999"
                    }
                  },
                },
              },
              barWidth: 20, //设置柱子宽度，单位为px
            },
          ],
        };
        myChart3.setOption(option3);
      });
    },
  },
};
</script>
<style scoped>
.el-range-editor {
  width: 120%;
}
.el-range-editor >>> .el-range-separator {
  width: 8%;
}
::v-deep .el-form .el-input__inner {
  width: 189px;
  height: 32px;
  border-radius: 3px;
  background: #fff;
  border: 1px solid #ddd;
}

::v-deep .el-table__header tr th {
  background: #f7f7f7;
  box-shadow: 0px 1px 0px #eaeaea;
}

::v-deep .el-date-editor .el-range-separator {
  line-height: 22px;
}
</style>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
  padding: 0 0 2% 2%;
}
.query {
  position: relative;
  margin-bottom: 2%;
}
.searchBtn {
  position: absolute;
  top: 50%;
  right: 5%;
}
.el-pagination {
  margin: 20px 0;
  padding-bottom: 30px;
  text-align: center;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.title {
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #eaeaea;
  margin-bottom: 10px;
  span {
    font-family: "PingFang SC Bold";
    font-weight: bold;
    font-size: 20px;
    text-align: left;
    color: #000;
  }
}

header{
    width: 100%;
    height: 350px;
    display: flex;
    .header-item{
      width: 50%;
      .header-item-title{
        font-size: 18px;
        color: #333;
        display: flex;
        align-items: center;
        .circle{
          width: 8px;
          height: 8px;
          display: inline-block;
          background: #4991e1;
          border-radius: 50%;
          margin-right: 10px;
        }
      }
      .header-item-text{
        font-size: 14px;
        color: #666;
        padding-left: 20px;
        margin-top: 5px;
      }
    }
    #echarts-box1{
      width:70%;
      height:280px;
    }
	#echarts-box2{
		width: 80%;
		height:280px;
	}
  #echarts-box3{
		width: 90%;
		height:280px;
	}
}
</style>
